// css
import 'bootstrap/dist/css/bootstrap.css';
import './assets/css/bootstrap.min.css';
import './assets/css/custom.css';
import './assets/css/app.min.css';
import './assets/css/icons.css';
import './assets/css/tui-date-picker.min.css';
import './assets/css/tui-time-picker.min.css';
import './assets/css/tui-calendar.min.css';
import './assets/scss/_colors.scss';
import './assets/scss/_colors.scss';
import './assets/scss/common.scss';
import 'react-toastify/dist/ReactToastify.css';
import 'react-phone-input-2/lib/style.css';

import React, {Suspense, useEffect} from 'react';
import {hot} from 'react-hot-loader/root';
import Amplify from 'aws-amplify';
import {Provider, useSelector} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import {store, persistor} from './redux/configureStore';
import Routes from './Routes';
import awsExports from './aws-exports';
import {ToastNotification, AppLoader, FloatingAssistant} from './components';
import ReactGA from 'react-ga';
import Bugsnag from '@bugsnag/js';

Amplify.configure(awsExports);
ReactGA.initialize('G-JJ5VFMNBLG', {
  titleCase: false,
});

function BugsnagUserSync() {
  const authState = useSelector(state => state.auth);
  const authDetails = authState?.authDetails;
  const authAttributes = authDetails?.attributes;
  const companyData = authState?.companyData;
  const member = authState?.companyData?.member;
  const branch = authState?.companyData?.branch;

  useEffect(() => {
    const userId =
      member?.id ||
      authAttributes?.sub ||
      authDetails?.username ||
      null;
    const email =
      member?.email ||
      authAttributes?.email ||
      authDetails?.username ||
      null;
    const name =
      [member?.firstName, member?.lastName].filter(Boolean).join(' ') ||
      [authAttributes?.given_name, authAttributes?.family_name].filter(Boolean).join(' ') ||
      member?.name ||
      null;

    if (userId || email || name) {
      Bugsnag.setUser(userId, email, name);
    } else {
      Bugsnag.setUser(null, null, null);
    }

    const userContext = {
      cognitoUsername: authDetails?.username || null,
      cognitoSub: authAttributes?.sub || null,
      memberId: member?.id || null,
      memberName:
        member?.name || [member?.firstName, member?.lastName].filter(Boolean).join(' ') || null,
      memberFirstName: member?.firstName || authAttributes?.given_name || null,
      memberLastName: member?.lastName || authAttributes?.family_name || null,
      memberEmail: member?.email || authAttributes?.email || null,
      memberPhone: member?.phone || null,
      memberUuid: member?.uuid || null,
      memberActiveBranchId: member?.memberActiveBranchId || null,
      companyId: companyData?.id || companyData?.companyId || null,
      companyName: companyData?.name || null,
      branchId: branch?.id || null,
      branchName: branch?.name || null,
      branchTimezone: branch?.timezone || null,
    };

    const filteredUserContext = Object.fromEntries(
      Object.entries(userContext).filter(([, value]) => value !== null && value !== '')
    );

    if (Object.keys(filteredUserContext).length > 0) {
      Bugsnag.addMetadata('userContext', filteredUserContext);
    } else {
      Bugsnag.clearMetadata('userContext');
    }
  }, [authAttributes, authDetails, branch, companyData, member]);

  return null;
}

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={<AppLoader />} persistor={persistor}>
        <BugsnagUserSync />
        <ToastNotification />
        {/* <FloatingAssistant /> */}
        <Suspense fallback={<AppLoader />}>
          <Routes />
        </Suspense>
      </PersistGate>
    </Provider>
  );
}

export default hot(App);
